import { gql } from '@apollo/client'

// UPLOAD_EVENTS

export default gql`
  subscription uploadEvents {
    upload_events {
      event_type
      upload {
        id
        scan_status
        short_url
      }
    }
  }
`
